import * as browserUtils from '@tolk-ai/browser-utils';
import * as genericUtils from '@tolk-ai/generic-utils';

var CreateOneMessengerLoginConfigErrors;

(function (CreateOneMessengerLoginConfigErrors) {
  CreateOneMessengerLoginConfigErrors[CreateOneMessengerLoginConfigErrors["inexistingBot"] = 0] = "inexistingBot";
})(CreateOneMessengerLoginConfigErrors || (CreateOneMessengerLoginConfigErrors = {}));

var GetOneMessengerChannelConfigErrors;

(function (GetOneMessengerChannelConfigErrors) {
  GetOneMessengerChannelConfigErrors[GetOneMessengerChannelConfigErrors["inexistingMessengerChannelConfig"] = 0] = "inexistingMessengerChannelConfig";
})(GetOneMessengerChannelConfigErrors || (GetOneMessengerChannelConfigErrors = {}));

var AuthenticateWithMessengerLoginErrors;

(function (AuthenticateWithMessengerLoginErrors) {
  AuthenticateWithMessengerLoginErrors[AuthenticateWithMessengerLoginErrors["inexistingLoginConfig"] = 0] = "inexistingLoginConfig";
  AuthenticateWithMessengerLoginErrors[AuthenticateWithMessengerLoginErrors["channelPageIdsAlreadyExists"] = 1] = "channelPageIdsAlreadyExists";
})(AuthenticateWithMessengerLoginErrors || (AuthenticateWithMessengerLoginErrors = {}));

var applicationPorts = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get AuthenticateWithMessengerLoginErrors () { return AuthenticateWithMessengerLoginErrors; },
  get CreateOneMessengerLoginConfigErrors () { return CreateOneMessengerLoginConfigErrors; },
  get GetOneMessengerChannelConfigErrors () { return GetOneMessengerChannelConfigErrors; }
});

const createOneMessengerLoginConfig$2 = authenticatedRequest => async botId => {
  try {
    const result = await authenticatedRequest('post', `/v1/bots/${botId}/connectors-config/messenger-login`);
    return result;
  } catch (error) {
    if (browserUtils.isAxiosRestError(error) && error.response.data.error === 'inexistingBot') {
      return null;
    }

    throw genericUtils.sanitizeError(error);
  }
};

const getOneMessengerChannelConfig$2 = authenticatedRequest => async botId => {
  try {
    const result = await authenticatedRequest('get', `/v1/bots/${botId}/connectors-config/messenger-login`);
    return result;
  } catch (error) {
    if (browserUtils.isAxiosRestError(error) && error.response.data.error === 'inexistingMessengerChannelConfig') {
      return null;
    }

    throw genericUtils.sanitizeError(error);
  }
};

const convertRestMessengerLoginConfigToMessengerLoginConfig = restMessengerLoginConfig => ({
  botId: restMessengerLoginConfig.botId,
  state: restMessengerLoginConfig.state,
  url: restMessengerLoginConfig.url
});

const convertRestMessengerChannelConfigToMessengerChannelConfig = restMessengerChannelConfig => ({
  botId: restMessengerChannelConfig.botId,
  pagesConfig: restMessengerChannelConfig.pagesConfig,
  userAccessToken: restMessengerChannelConfig.userAccessToken
});

const createOneMessengerLoginConfig$1 = authenticatedRequest => async botId => {
  const result = await createOneMessengerLoginConfig$2(authenticatedRequest)(botId);

  if (result === null) {
    return CreateOneMessengerLoginConfigErrors.inexistingBot;
  }

  return convertRestMessengerLoginConfigToMessengerLoginConfig(result);
};

const getOneMessengerChannelConfig$1 = authenticatedRequest => async botId => {
  const result = await getOneMessengerChannelConfig$2(authenticatedRequest)(botId);

  if (result === null) {
    return GetOneMessengerChannelConfigErrors.inexistingMessengerChannelConfig;
  }

  return convertRestMessengerChannelConfigToMessengerChannelConfig(result);
};

var index$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createOneMessengerLoginConfig: createOneMessengerLoginConfig$1,
  getOneMessengerChannelConfig: getOneMessengerChannelConfig$1
});

const getUserAccessTokenFacebookByCode = (axios, facebookApplicationId, facebookApplicationSecret, redirectUri) => async code => {
  try {
    const result = await axios.get(`https://graph.facebook.com/v12.0/oauth/access_token?client_id=${facebookApplicationId}&redirect_uri=${redirectUri}&client_secret=${facebookApplicationSecret}&code=${code}`);
    return result.data;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getPagesFacebook = axios => async accesstoken => {
  try {
    const result = await axios.get(`https://graph.facebook.com/v12.0/me/accounts?access_token=${accesstoken}&fields=id%2Cname%2Caccess_token&limit=999`);
    return result.data;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertRestPagesFacebookToPageConfig = pageFacebook => ({
  accessToken: pageFacebook.access_token,
  id: pageFacebook.id,
  name: pageFacebook.name
});

const getOneMessengerChannelConfigByCode = (axios, facebookApplicationId, facebookApplicationSecret, redirectUri) => async (code, botId) => {
  const restAccessToken = await getUserAccessTokenFacebookByCode(axios, facebookApplicationId, facebookApplicationSecret, redirectUri)(code);
  const restPagesFacebook = await getPagesFacebook(axios)(restAccessToken.access_token);
  const pagesConfig = typeof restPagesFacebook.data === 'undefined' ? [] : restPagesFacebook.data.map(pageFacebook => convertRestPagesFacebookToPageConfig(pageFacebook));
  return {
    botId,
    pagesConfig,
    userAccessToken: restAccessToken.access_token
  };
};

var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getOneMessengerChannelConfigByCode: getOneMessengerChannelConfigByCode
});

const getOneMongoBotByBotId = mongodb => async botId => mongodb.collection('api_bots').findOne({
  bot_id: botId
});

const convertMongodbBotToBot = mongodbBot => ({
  id: mongodbBot.bot_id
});

const getOneBotByBotId = mongodb => async botId => {
  const result = await getOneMongoBotByBotId(mongodb)(botId);

  if (result === null) {
    return null;
  }

  return convertMongodbBotToBot(result);
};

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getOneBotByBotId: getOneBotByBotId
});

const saveOnePgMessengerLoginConfig = pool => async messengerLoginConfig => {
  try {
    await pool.query(`INSERT INTO messenger_login_config(
          bot_id,
          state,
          url
        )
        VALUES ($1, $2, $3)
        ON CONFLICT (bot_id)
        DO UPDATE SET
        state=$2,
        url=$3;`, [messengerLoginConfig.botId, messengerLoginConfig.state, messengerLoginConfig.url]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOnePgMessengerChannelConfigByBotId = pool => async botId => {
  try {
    const result = (await pool.query(`SELECT
        "messenger_channel_config".id,
        "messenger_channel_config".bot_id,
        "messenger_channel_config".user_access_token,
        "messenger_page_config"."name",
        "messenger_page_config".access_token
      FROM messenger_channel_config
      INNER JOIN messenger_page_config
      ON "messenger_page_config".messenger_channel_config_id = "messenger_channel_config".id
      WHERE bot_id = $1;`, [botId])).rows;

    if (genericUtils.isEmpty(result)) {
      return null;
    }

    return result;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOnePgMessengerLoginConfigByState = pool => async state => {
  var _a;

  try {
    const result = await pool.query(`SELECT
          bot_id,
          url,
          state
        FROM messenger_login_config
        WHERE state = $1;`, [state]);
    return (_a = result.rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const deleteOnePgMessengerLoginConfigByBotId = pool => async botId => {
  try {
    await pool.query(`DELETE FROM messenger_login_config WHERE bot_id = $1;`, [botId]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertPgMessengerChannelAndPagesConfigToMessengerChannelConfig = pgMessengerChannelAndPagesConfig => ({
  botId: pgMessengerChannelAndPagesConfig[genericUtils.ARRAY.FIRST_INDEX].bot_id,
  pagesConfig: pgMessengerChannelAndPagesConfig.map(pgMessengerPageConfig => ({
    accessToken: pgMessengerPageConfig.access_token,
    id: pgMessengerChannelAndPagesConfig[genericUtils.ARRAY.FIRST_INDEX].id.toString(),
    name: pgMessengerPageConfig.name
  })),
  userAccessToken: pgMessengerChannelAndPagesConfig[genericUtils.ARRAY.FIRST_INDEX].user_access_token
});

const convertPgMessengerLoginConfigToMessengerLoginConfig = pgMessengerLoginConfig => ({
  botId: pgMessengerLoginConfig.bot_id,
  state: pgMessengerLoginConfig.state,
  url: pgMessengerLoginConfig.url
});

const saveOneMessengerLoginConfig = pool => async messengerLoginConfig => {
  await saveOnePgMessengerLoginConfig(pool)(messengerLoginConfig);
};

const getOneMessengerChannelConfigByBotId = pool => async botId => {
  const pgMessengerChannelAndPagesConfig = await getOnePgMessengerChannelConfigByBotId(pool)(botId);

  if (pgMessengerChannelAndPagesConfig === null) {
    return null;
  }

  return convertPgMessengerChannelAndPagesConfigToMessengerChannelConfig(pgMessengerChannelAndPagesConfig);
};

const getOneMessengerLoginConfigByState = pool => async state => {
  const pgMessengerLoginConfig = await getOnePgMessengerLoginConfigByState(pool)(state);

  if (pgMessengerLoginConfig === null) {
    return null;
  }

  return convertPgMessengerLoginConfigToMessengerLoginConfig(pgMessengerLoginConfig);
};

const deleteOneMessengerLoginConfigByBotId = pool => async botId => {
  await deleteOnePgMessengerLoginConfigByBotId(pool)(botId);
};

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  deleteOneMessengerLoginConfigByBotId: deleteOneMessengerLoginConfigByBotId,
  getOneMessengerChannelConfigByBotId: getOneMessengerChannelConfigByBotId,
  getOneMessengerLoginConfigByState: getOneMessengerLoginConfigByState,
  saveOneMessengerLoginConfig: saveOneMessengerLoginConfig
});

var SaveOneMessengerChannelConfigErrors;

(function (SaveOneMessengerChannelConfigErrors) {
  SaveOneMessengerChannelConfigErrors[SaveOneMessengerChannelConfigErrors["channelPageIdsAlreadyExists"] = 0] = "channelPageIdsAlreadyExists";
})(SaveOneMessengerChannelConfigErrors || (SaveOneMessengerChannelConfigErrors = {}));

const saveOnePgMessengerChannelConfig = pool => async messengerChannelConfig => {
  try {
    await pool.query(`INSERT INTO messenger_channel_config(
        bot_id,
        user_access_token
      )
      VALUES ($1, $2)
      ON CONFLICT (bot_id) DO UPDATE SET
      user_access_token=$2;`, [messengerChannelConfig.botId, messengerChannelConfig.userAccessToken]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const saveOnePgMessengerPageConfig = pool => async (pageConfig, botId) => {
  try {
    await pool.query(`INSERT INTO messenger_page_config(
          messenger_channel_config_id,
          name,
          access_token,
          page_id
        )
        VALUES ((SELECT "messenger_channel_config".id FROM messenger_channel_config WHERE "messenger_channel_config".bot_id = $1), $2, $3, $4);`, [botId, pageConfig.name, pageConfig.accessToken, pageConfig.id]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getManyPgPagesConfigByBotId = pool => async botId => {
  try {
    const result = await pool.query(`SELECT *
        FROM messenger_page_config
        WHERE messenger_channel_config_id = (
          SELECT "messenger_channel_config".id FROM messenger_channel_config WHERE "messenger_channel_config".bot_id = $1
        )
      `, [botId]);
    return result.rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const saveManyPgMessengerPageConfig = pool => async (messengerPagesConfig, botId) => {
  await Promise.all(messengerPagesConfig.map(async pageConfig => saveOnePgMessengerPageConfig(pool)(pageConfig, botId)));
};

const deleteOnePgMessengerPagesConfig = pool => async pgMessengerPageConfig => {
  try {
    await pool.query(`DELETE FROM messenger_page_config
      WHERE page_id = $1
      AND messenger_channel_config_id = $2
    `, [pgMessengerPageConfig.page_id, pgMessengerPageConfig.messenger_channel_config_id]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const deleteManyPgMessengerPagesConfig = pool => async pgMessengerPagesConfig => {
  await Promise.all(pgMessengerPagesConfig.map(async pgMessengerPageConfig => {
    await deleteOnePgMessengerPagesConfig(pool)(pgMessengerPageConfig);
  }));
};

const saveManyAxiosMessengerChannels = axiosBotManagment => async (restMessengerChannel, botId) => {
  try {
    await axiosBotManagment.post(`/v1/bots/${botId}/channels`, restMessengerChannel);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertPageConfigsToRestMessengerChannels = pageConfigs => ({
  channels: pageConfigs.map(pageConfig => ({
    name: pageConfig.name,
    options: {
      pageId: pageConfig.id,
      pageToken: pageConfig.accessToken
    },
    slug: 'messenger'
  }))
});

const findManyMongodbMessengerChannelIds = mongodb => async (botId, pageIds) => {
  try {
    const mongoMessengerChannels = await mongodb.collection('api_channels').find({
      bot_id: botId,
      'options.pageId': {
        $in: pageIds
      },
      slug: 'messenger'
    }, {
      projection: {
        _id: 1
      }
    }).toArray();
    return mongoMessengerChannels.map(mongoMessengerChannel => mongoMessengerChannel._id);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const updateManyMongodbMessengerChannels = mongodb => async channelIds => {
  try {
    await mongodb.collection('api_channels').updateMany({
      _id: {
        $in: channelIds
      },
      slug: 'messenger'
    }, {
      $set: {
        isActivate: false
      }
    });
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const updateChannelsMongodbBot = mongodb => async (botId, channelIds) => {
  try {
    await mongodb.collection('api_bots').updateOne({
      bot_id: botId
    }, {
      $pull: {
        channels: {
          $in: channelIds
        }
      }
    });
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const updateManyMongodbMessengerChannelByBotId = mongodb => async (botId, pgMessengerPagesConfig) => {
  const pageIds = pgMessengerPagesConfig.map(pgMessengerPageConfig => pgMessengerPageConfig.page_id);
  const mongodbChannelIds = await findManyMongodbMessengerChannelIds(mongodb)(botId, pageIds);
  await updateManyMongodbMessengerChannels(mongodb)(mongodbChannelIds);
  await updateChannelsMongodbBot(mongodb)(botId, mongodbChannelIds);
};

const getPagesConfigToDelete = (pgMessengerPagesConfig, messengerChannelConfig) => {
  const pagesConfigId = new Set(messengerChannelConfig.pagesConfig.map(pageConfig => pageConfig.id));
  return pgMessengerPagesConfig.map(pgMessengerPageConfig => {
    if (pagesConfigId.has(pgMessengerPageConfig.page_id)) {
      return null;
    }

    return pgMessengerPageConfig;
  }).filter(value => value !== null);
};

const getPagesConfigToAdd = (pgMessengerPagesConfig, messengerChannelConfig) => {
  const pgPagesConfigId = new Set(pgMessengerPagesConfig.map(pgMessengerPageConfig => pgMessengerPageConfig.page_id));
  return messengerChannelConfig.pagesConfig.map(pageConfig => {
    if (pgPagesConfigId.has(pageConfig.id)) {
      return null;
    }

    return pageConfig;
  }).filter(value => value !== null);
};

const addMessengeGetStartedButton = axios => async accessToken => {
  const body = {
    get_started: {
      payload: 'GET_STARTED'
    }
  };

  try {
    await axios.post(`https://graph.facebook.com/v13.0/me/messenger_profile?access_token=${accessToken}`, body);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const addMessengerWebhookEvents = axios => async (pageId, accessToken) => {
  try {
    const searchParameters = new URLSearchParams();
    searchParameters.append('subscribed_fields', "['messages','messaging_postbacks','messaging_referrals','message_echoes']");
    searchParameters.append('access_token', accessToken);
    const stringSearchParameters = searchParameters.toString();
    const uri = `https://graph.facebook.com/${pageId}/subscribed_apps?${stringSearchParameters}`;
    await axios.post(uri);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const isChannelPageIdAlreadyExistsForAnotherBot = mongodb => async (pagesConfig, botId) => {
  try {
    const pagesConfigId = pagesConfig.map(pageConfig => pageConfig.id);
    const mongoMessengerChannels = await mongodb.collection('api_channels').find({
      bot_id: {
        $nin: [botId]
      },
      isActivate: true,
      'options.pageId': {
        $in: pagesConfigId
      },
      slug: 'messenger'
    }).toArray();
    return !genericUtils.isEmpty(mongoMessengerChannels);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const saveOneMessengerChannelConfig = (pool, axiosInstanceBotManagement, mongodb, axiosStatic) => async messengerChannelConfig => {
  if (await isChannelPageIdAlreadyExistsForAnotherBot(mongodb)(messengerChannelConfig.pagesConfig, messengerChannelConfig.botId)) {
    return SaveOneMessengerChannelConfigErrors.channelPageIdsAlreadyExists;
  }

  const pgPagesConfig = await getManyPgPagesConfigByBotId(pool)(messengerChannelConfig.botId);
  const pagesConfigToDelete = getPagesConfigToDelete(pgPagesConfig, messengerChannelConfig);
  const pagesConfigToAdd = getPagesConfigToAdd(pgPagesConfig, messengerChannelConfig);
  await Promise.all(pagesConfigToAdd.map(async pageConfig => {
    await addMessengerWebhookEvents(axiosStatic)(pageConfig.id, pageConfig.accessToken);
    await addMessengeGetStartedButton(axiosStatic)(pageConfig.accessToken);
  }));

  if (pagesConfigToDelete.length > genericUtils.ARRAY.EMPTY_LENGTH) {
    await updateManyMongodbMessengerChannelByBotId(mongodb)(messengerChannelConfig.botId, pagesConfigToDelete);
    await deleteManyPgMessengerPagesConfig(pool)(pagesConfigToDelete);
  }

  await saveOnePgMessengerChannelConfig(pool)(messengerChannelConfig);
  await saveManyPgMessengerPageConfig(pool)(pagesConfigToAdd, messengerChannelConfig.botId);
  const restMessengerChannels = convertPageConfigsToRestMessengerChannels(pagesConfigToAdd);
  await saveManyAxiosMessengerChannels(axiosInstanceBotManagement)(restMessengerChannels, messengerChannelConfig.botId);
};

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  saveOneMessengerChannelConfig: saveOneMessengerChannelConfig
});

var $schema = "http://json-schema.org/draft-07/schema#";
var definitions = {
	RestMessengerLoginConfig: {
		type: "object",
		properties: {
			botId: {
				type: "string"
			},
			state: {
				type: "string"
			},
			url: {
				type: "string"
			}
		},
		required: [
			"botId",
			"state",
			"url"
		],
		additionalProperties: false
	},
	RestPageConfig: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			name: {
				type: "string"
			},
			accessToken: {
				type: "string"
			}
		},
		required: [
			"id",
			"name",
			"accessToken"
		],
		additionalProperties: false
	},
	RestMessengerChannelConfig: {
		type: "object",
		properties: {
			userAccessToken: {
				type: "string"
			},
			pagesConfig: {
				type: "array",
				items: {
					$ref: "#/definitions/RestPageConfig"
				}
			},
			botId: {
				type: "string"
			}
		},
		required: [
			"userAccessToken",
			"pagesConfig",
			"botId"
		],
		additionalProperties: false
	},
	BotId: {
		type: "string"
	},
	Bot: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/BotId"
			}
		},
		required: [
			"id"
		],
		additionalProperties: false
	},
	State: {
		type: "string"
	},
	Code: {
		type: "string"
	},
	PageConfig: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			name: {
				type: "string"
			},
			accessToken: {
				type: "string"
			}
		},
		required: [
			"id",
			"name",
			"accessToken"
		],
		additionalProperties: false
	},
	MessengerLoginConfig: {
		type: "object",
		properties: {
			botId: {
				$ref: "#/definitions/BotId"
			},
			state: {
				type: "string"
			},
			url: {
				type: "string"
			}
		},
		required: [
			"botId",
			"state",
			"url"
		],
		additionalProperties: false
	},
	MessengerChannelConfig: {
		type: "object",
		properties: {
			userAccessToken: {
				type: "string"
			},
			pagesConfig: {
				type: "array",
				items: {
					$ref: "#/definitions/PageConfig"
				}
			},
			botId: {
				$ref: "#/definitions/BotId"
			}
		},
		required: [
			"userAccessToken",
			"pagesConfig",
			"botId"
		],
		additionalProperties: false
	},
	RestUserAccessToken: {
		type: "object",
		properties: {
			access_token: {
				type: "string"
			},
			token_type: {
				type: "string"
			},
			expires_in: {
				type: "string"
			}
		},
		required: [
			"access_token",
			"token_type",
			"expires_in"
		],
		additionalProperties: false
	},
	PageFacebook: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			name: {
				type: "string"
			},
			access_token: {
				type: "string"
			}
		},
		required: [
			"id",
			"name",
			"access_token"
		],
		additionalProperties: false
	},
	RestPagesFacebook: {
		type: "object",
		properties: {
			data: {
				type: "array",
				items: {
					$ref: "#/definitions/PageFacebook"
				}
			}
		},
		required: [
			"data"
		],
		additionalProperties: false
	},
	MongoBot: {
		type: "object",
		properties: {
			bot_id: {
				$ref: "#/definitions/BotId"
			}
		},
		required: [
			"bot_id"
		],
		additionalProperties: false
	},
	PgMessengerChannelConfigId: {
		type: "string"
	},
	PgMessengerChannelConfig: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/PgMessengerChannelConfigId"
			},
			bot_id: {
				type: "string"
			},
			user_access_token: {
				type: "string"
			}
		},
		required: [
			"id",
			"bot_id",
			"user_access_token"
		],
		additionalProperties: false
	},
	PgMessengerPageConfig: {
		type: "object",
		properties: {
			messenger_channel_config_id: {
				type: "number"
			},
			name: {
				type: "string"
			},
			access_token: {
				type: "string"
			},
			page_id: {
				type: "string"
			}
		},
		required: [
			"messenger_channel_config_id",
			"name",
			"access_token",
			"page_id"
		],
		additionalProperties: false
	},
	PgMessengerPagesConfig: {
		type: "array",
		items: {
			$ref: "#/definitions/PgMessengerPageConfig"
		}
	},
	MongodbChannelId: {
		type: "string"
	},
	MongodbChannelIds: {
		type: "array",
		items: {
			$ref: "#/definitions/MongodbChannelId"
		}
	},
	MongodbMessengerChannelOptions: {
		type: "object",
		properties: {
			pageId: {
				type: "string"
			},
			pageToken: {
				type: "string"
			}
		},
		required: [
			"pageId",
			"pageToken"
		],
		additionalProperties: false
	},
	MongodbMessengerChannel: {
		type: "object",
		properties: {
			_id: {
				type: "string"
			},
			slug: {
				type: "string",
				"const": "messenger"
			},
			bot_id: {
				type: "string"
			},
			isActivate: {
				type: "boolean"
			},
			options: {
				$ref: "#/definitions/MongodbMessengerChannelOptions"
			}
		},
		required: [
			"_id",
			"slug",
			"bot_id",
			"isActivate",
			"options"
		],
		additionalProperties: false
	},
	MongodbMessengerChannels: {
		type: "array",
		items: {
			$ref: "#/definitions/MongodbMessengerChannel"
		}
	},
	MongodbBot: {
		type: "object",
		properties: {
			bot_id: {
				type: "string"
			},
			channels: {
				$ref: "#/definitions/MongodbChannelIds"
			}
		},
		required: [
			"bot_id",
			"channels"
		],
		additionalProperties: false
	},
	RestMessengerChannel: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			slug: {
				type: "string",
				"const": "messenger"
			},
			options: {
				type: "object",
				properties: {
					pageId: {
						type: "string"
					},
					pageToken: {
						type: "string"
					}
				},
				required: [
					"pageId",
					"pageToken"
				],
				additionalProperties: false
			}
		},
		required: [
			"name",
			"slug",
			"options"
		],
		additionalProperties: false
	},
	RestMessengerChannels: {
		type: "object",
		properties: {
			channels: {
				type: "array",
				items: {
					$ref: "#/definitions/RestMessengerChannel"
				}
			}
		},
		required: [
			"channels"
		],
		additionalProperties: false
	},
	PgMessengerLoginConfig: {
		type: "object",
		properties: {
			bot_id: {
				type: "string"
			},
			state: {
				type: "string"
			},
			url: {
				type: "string"
			}
		},
		required: [
			"bot_id",
			"state",
			"url"
		],
		additionalProperties: false
	},
	PgMessengerChannelAndPagesConfig: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/PgMessengerChannelConfigId"
			},
			bot_id: {
				type: "string"
			},
			user_access_token: {
				type: "string"
			},
			name: {
				type: "string"
			},
			access_token: {
				type: "string"
			}
		},
		required: [
			"id",
			"bot_id",
			"user_access_token",
			"name",
			"access_token"
		],
		additionalProperties: false
	}
};
var entitiesSchemas = {
	$schema: $schema,
	definitions: definitions
};

var entitiesSchemas$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  $schema: $schema,
  definitions: definitions,
  'default': entitiesSchemas
});

const generateUrl = (botManagementExpressRedirectUrl, facebookApplicationId, state) => `https://www.facebook.com/dialog/oauth?response_type=code%20granted_scopes&display=popup&client_id=${facebookApplicationId}&redirect_uri=${botManagementExpressRedirectUrl}&state=${state}&scope=pages_messaging%2Cpages_manage_metadata`;

const messengerLoginConfigFactory = (botManagementExpressRedirectUrl, facebookApplicationId) => botId => {
  const state = genericUtils.generateRandomString();
  return {
    botId,
    state,
    url: generateUrl(botManagementExpressRedirectUrl, facebookApplicationId, state)
  };
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  messengerLoginConfigFactory: messengerLoginConfigFactory
});

const createOneMessengerLoginConfig = (getOneBotByBotId, messengerLoginConfigFactory, saveOneMessengerLoginConfig) => async botId => {
  const bot = await getOneBotByBotId(botId);

  if (!bot) {
    return CreateOneMessengerLoginConfigErrors.inexistingBot;
  }

  const messengerLoginConfig = messengerLoginConfigFactory(botId);
  await saveOneMessengerLoginConfig(messengerLoginConfig);
  return messengerLoginConfig;
};

const getOneMessengerChannelConfig = getOneMessengerChannelConfigByBotId => async botId => {
  const messengerChannelConfig = await getOneMessengerChannelConfigByBotId(botId);

  if (messengerChannelConfig === null) {
    return GetOneMessengerChannelConfigErrors.inexistingMessengerChannelConfig;
  }

  return messengerChannelConfig;
};

const authenticateWithMessengerLogin = (getOneMessengerLoginConfigByState, getOneMessengerChannelConfigByCode, saveOneMessengerChannelConfig, deleteOneMessengerLoginConfigByBotId) => async (state, code) => {
  const loginConfig = await getOneMessengerLoginConfigByState(state);

  if (loginConfig === null) {
    return AuthenticateWithMessengerLoginErrors.inexistingLoginConfig;
  }

  const channelConfig = await getOneMessengerChannelConfigByCode(code, loginConfig.botId);
  const saveMessengerChannelConfig = await saveOneMessengerChannelConfig(channelConfig);
  await deleteOneMessengerLoginConfigByBotId(loginConfig.botId);

  if (saveMessengerChannelConfig === SaveOneMessengerChannelConfigErrors.channelPageIdsAlreadyExists) {
    return AuthenticateWithMessengerLoginErrors.channelPageIdsAlreadyExists;
  }

  return channelConfig;
};

export { applicationPorts as appPorts, authenticateWithMessengerLogin, index$4 as axiosBotsRepository, index$5 as axiosMessenger, index as botModel, createOneMessengerLoginConfig, entitiesSchemas$1 as entitiesSchemas, getOneMessengerChannelConfig, index$3 as mongoDatabaseBotsRepository, index$2 as postgresqlBotsRepository, index$1 as postgresqlMongoDatabaseAxiosBotsRepository };
